import { Button, Dialog } from "@sportsmet/ui";
import type { ReactNode } from "react";

import {
  buildAutoConfirmedSubtitle,
  CONFIRM_GATE_AUTO_CONFIRMED_ACTION,
  CONFIRM_GATE_AUTO_CONFIRMED_TITLE,
} from "./confirmGateCopy";

export type typeContestAutoConfirmedNoticeProps = {
  open: boolean;
  winnerNames: readonly string[];
  medalName: string;
  onSeeResults: () => void;
};

export const ContestAutoConfirmedNotice = ({
  open,
  winnerNames,
  medalName,
  onSeeResults,
}: typeContestAutoConfirmedNoticeProps): ReactNode => {
  return (
    <Dialog
      open={open}
      onOpenChange={() => undefined}
      title={CONFIRM_GATE_AUTO_CONFIRMED_TITLE}
      isDirty={true}
      onRequestClose={() => undefined}
      hideCloseButton
      autoFocus={false}
      footer={
        <Button variant="primary" fullWidth onClick={onSeeResults}>
          {CONFIRM_GATE_AUTO_CONFIRMED_ACTION}
        </Button>
      }
    >
      <p data-testid="confirm-gate-auto-confirmed-subtitle">
        {buildAutoConfirmedSubtitle({ winnerNames, medalName })}
      </p>
    </Dialog>
  );
};
